export default __webpack_public_path__ + "static/media/adventure-icon.05f2e3fc.png";